import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const OfflineLayer = () => {
  const triggerTryAgain = () => {
    window.location.href = '/';
  };

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      triggerTryAgain();
    }, 10000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <div className='card basic-data-table'>
      <div className='card-body py-80 px-32 text-center'>
        <img src='assets/images/offline-img.png' width="25%" alt='' className='mb-24' />
        <h6 className='mb-16'>Application Offline</h6>
        <p className='text-secondary-light'>
          We are unable to connect to the server. Please try again later.
        </p>
        <Link
          to='/'
          className='btn btn-primary-600 radius-8 px-20 py-11'
          onClick={(event) => {
            event.preventDefault();
            triggerTryAgain();
          }}
        >
          Try Again
        </Link>
      </div>
    </div>
  );
};

export default OfflineLayer;
